import React from 'react';
import { PinCardOverlayProps } from '@/experiences/sales-portal/domain/prospects/screens/prospect-finder/components/pin-card-overlay-types';

// Web shows the card in-map (business-pin-card.web), so there's no overlay.
export const PinCardOverlay: React.FC<PinCardOverlayProps> = () => null;
